import * as React from 'react';
import type { SVGProps } from 'react';
const SvgZlogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="zscaler logo"
    viewBox="0 0 90 90"
    {...props}
  >
    <path
      fill="#256CF7"
      d="M75.094 59.752c7.635-.545 15.27-5.68 13.83-14.781-3.087-19.654-35.437-15.62-44.436-1.188.819-.916 23.854-11.773 34.041.294 2.716 3.194-.098 11.729-10.907 8.099-20.221-6.813-36.822 6.377-42.275 13.713 2.694 3.193 5.453 4.13 9.5 4.13a17.5 17.5 0 0 0 3.108-.283A27.3 27.3 0 0 0 51.6 72.832c11.583 0 19.6-5.864 23.494-13.08"
    />
    <path
      fill="#256CF7"
      d="M40.224 30.332c10.362-4.666 17.767-1.93 17.702-1.93-27.115 9.876-33.801 28.94-35.437 37.138a1.5 1.5 0 0 0-.546 0C14.539 67.622 1.526 59.893.927 47.5c-.6-12.394 9.445-23.305 21.018-23.305a20.5 20.5 0 0 1 4.526.48c4.8-5.179 12.369-8.525 20.909-8.525 7.7 0 12.98.632 17.8 4.873-7.482-1.09-16.219 1.842-26.177 8.72q.594.327 1.222.588"
    />
  </svg>
);
export default SvgZlogo;
